export const sortedColor = "#14FF29";
export const swapColor = "#F60000";
export const compareColor = "#1033FF";
export const shiftColor = "#FF7F11";
export const defaultBarColor = "#9CA3AF";
